export default __webpack_public_path__ + "static/media/DSC_0581.17cde5c6.webp";